"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IcicleStormAbilityHandler = exports.IcicleStormActorAbilityFactory = exports.IcicleStormAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class IcicleStormAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.IcicleStorm;
        this.__typeName = "IcicleStorm";
    }
}
exports.IcicleStormAbilityArgs = IcicleStormAbilityArgs;
let IcicleStormActorAbilityFactory = class IcicleStormActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("IcicleStorm", "AllEnemies", 0);
    }
};
IcicleStormActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("IcicleStorm")
], IcicleStormActorAbilityFactory);
exports.IcicleStormActorAbilityFactory = IcicleStormActorAbilityFactory;
let IcicleStormAbilityHandler = class IcicleStormAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const allies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies);
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            projectiles: Array((0, Random_1.random)(1, 3)).fill(0)
                .map(() => ({
                creatorId: ability.invokerId,
                targetId: (0, Random_1.randomElement)(enemies),
                jitter: (0, Random_1.random)(25, 225),
                type: "IceShardRotating",
                path: "arc",
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Frost", 50),
                    AbilityDamage_1.AbilityDamage.Focus("Death", 50),
                ]
            })),
            onHit: (sequence, _attack, _damages, { targetId }) => {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet", "front"), "IceExplosion"));
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: (0, Random_1.randomElement)(allies),
                    duration: Duration_1.Duration.Turns(2),
                    effect: new core_2.ReciprocateAttackEffectArgs(Duration_1.Duration.Ticks(8), new core_2.FrostBittenEffectArgs("Focus", 10), true, 100),
                    onApplied: (sequence, { targetId }) => {
                        sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "IceWindsPillar"));
                    }
                });
            }
        });
    }
};
IcicleStormAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.IcicleStorm)
], IcicleStormAbilityHandler);
exports.IcicleStormAbilityHandler = IcicleStormAbilityHandler;
